import React, { useState } from 'react';
import "../../iqac.css"
import TopNav from '../../../../../Components/TopNav';
import Navbar from '../../../../../Components/Navbar';
import DropdownNav from '../../../../../Components/DropdownNav';
import Footer from '../../../../../Components/Footer';
import Example from '../../../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';

const Policies = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='pol-image'>
          <div className='image-cover'>

          </div>
        </div>

      </div>

      {/* This iqac details part */}

      <div className='iqac-details'>
        <div className='iqac-header'>
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className='iqac-obj-tit'>Policies</h1>
        </div>
      </div>

      <div className='iqac-obj-det'>
        <button onClick={() => setIsOpen(e => !e)}           style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}>Policies</button>
        {
          isOpen && (
            <div className='ssr-items'>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/Maintenance_Policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Maintenance Policy</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/admission_policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>
                      Admission Policy</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/research-policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>
                      Research Policy</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/student_mentoring_and_counselling_policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>STUDENT MENTORING & COUNSELLING POLICY</h3>
                  </a>
                </div>
              </div>

              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/policy_on_it_infrastructure.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>IT Policy</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/Grievance-Redressal-Policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Grievance Redressal Policy</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='#' target='new'>
                    {/* This is the text format in the webpage so first convert the image to pdf and next upload the file */}
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>The New College Innovation & Start Up Policy (NCISP)</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/teaching-policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Teaching Policy</h3>
                  </a>
                </div>
              </div>


              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/differently-abled-friendly-campus-policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Differently Abled Friendly Campus Policy</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/green-campus-policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Green Campus Policy</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/policy-on-celebration-of-days-and-events.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Policy on Celebration of Days and Events</h3>
                  </a>
                </div>
              </div>


            </div>
          )

        }


      </div>

      <Footer />


    </div>
  );
}

export default Policies;
